import React, { useState, useRef, useEffect } from 'react';
import Icon from 'components/AppIcon';

const MARKETPLACE_TABS = [
  {
    id: 'products',
    label: 'Products',
    icon: 'Package',
    count: null,
  },
  {
    id: 'services',
    label: 'Services',
    icon: 'Briefcase',
    count: null,
  },
  {
    id: 'merch',
    label: 'WIN Merch',
    icon: 'Star',
    count: null,
  },
];

export default function MarketplaceTabs({ activeTab = 'products', onTabChange, className = '' }) {
  const [currentTab, setCurrentTab] = useState(activeTab);
  const tabsRef = useRef(null);

  useEffect(() => {
    setCurrentTab(activeTab);
  }, [activeTab]);

  const handleTabClick = (tabId) => {
    setCurrentTab(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }

    // Scroll active tab into view on mobile
    if (tabsRef?.current) {
      const activeEl = tabsRef?.current?.querySelector(`[data-tab="${tabId}"]`);
      if (activeEl) {
        activeEl?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  };

  return (
    <div className={`${className}`} role="tablist" aria-label="Marketplace categories">
      <div className="marketplace-tabs" ref={tabsRef}>
        {MARKETPLACE_TABS?.map((tab) => {
          const isActive = currentTab === tab?.id;
          return (
            <button
              key={tab?.id}
              data-tab={tab?.id}
              role="tab"
              aria-selected={isActive}
              aria-controls={`tabpanel-${tab?.id}`}
              id={`tab-${tab?.id}`}
              className={`marketplace-tab ${isActive ? 'active' : ''}`}
              onClick={() => handleTabClick(tab?.id)}
            >
              <Icon
                name={tab?.icon}
                size={16}
                color={isActive ? 'var(--color-primary)' : 'currentColor'}
                strokeWidth={isActive ? 2 : 1.75}
              />
              <span>{tab?.label}</span>
              {tab?.count !== null && (
                <span
                  className={`inline-flex items-center justify-center rounded-full font-caption font-medium
                    ${isActive
                      ? 'bg-primary text-white' :'bg-muted text-muted-foreground'
                    }`}
                  style={{ fontSize: '0.6875rem', minWidth: '20px', height: '20px', padding: '0 6px' }}
                >
                  {tab?.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}